import type { KeyMapping } from "cubing/puzzles/PuzzleLoader";
import type { AlgLeaf } from "./alg-nodes/AlgNode";

// TODO: options about whether to ignore modifier keys (e.g. alt, ctrl).
// TODO: Support different mappings.
// TODO: Return BaseMove instead?
export function keyToMove(
  keyMapping: KeyMapping | undefined,
  e: KeyboardEvent,
): AlgLeaf | null {
  if (e.altKey || e.ctrlKey) {
    return null;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code
  // > The KeyboardEvent.code property represents a physical key on the keyboard
  // > (as opposed to the character generated by pressing the key). In other
  // > words, this property returns a value that isn't altered by keyboard
  // > layout or the state of the modifier keys.
  const layoutIndepdendentCode = e.code;
  return keyMapping?.[layoutIndepdendentCode] ?? null;
}
